<template lang="pug">
#index
  .in
    .txt.txt_kr.on
      .top
        h2
          img.img(:src='require("../assets/images/index_logo.png")' alt='itk')
      .bot
        .b_in
          .b_top
            h3 LANGUAGE
            ul
              li.kr(:class='[lan == "kr" ? "on" : ""]')
                a(@click='langCk("kr")')
                  span.i_ck(:class='[lan == "kr" ? "i_cked" : ""]')
                  p KOR
              li.en(:class='[lan == "en" ? "on" : ""]')
                a(@click='langCk("en")')
                  span.i_ck(:class='[lan == "en" ? "i_cked" : ""]')
                  p ENG
          .b_mid(v-if='lan == "kr"')
            p
              | 이 사이트는 음주가 가능한 
              br
              span.yell 만 19세 이상만
              |  이용 가능합니다.
          .b_bot(v-if='lan == "kr"')
            a(@click='$_goTo({name: "home"})') 네, 만 19세 이상입니다.
          .b_mid(v-if='lan == "en"')
            p
              | To enter this site 
              br
              | you must be 
              span.yell at least 18 years old
              | .
          .b_bot.en_bot(v-if='lan == "en"')
            a(@click='$_goTo({name: "home"})') Yes, I am at least 18 years old.
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['lan']),
  },
  methods: {
    ...mapActions(['getLang']),
    langCk(payload) {
      this.getLang(payload);
    },
  },
};
</script>

<style scoped>
@import '../assets/css/index.css';
@media (max-width: 425px) {
  #index .in .txt .bot .en_bot {
    width: 85%;
  }
}
@media (max-width: 375px) {
  #index .in .txt .bot .en_bot {
    width: fit-content;
  }
}
</style>
